import type { ChipFilterValue } from '@openx/types/chipFilters';
import { type AllTableCriteria, CriteriaDimension, type PaginationCriteria } from '@openx/types/tableCriteria';
import type { Dispatch, SetStateAction } from 'react';

type UpdatePaginationArgs<TFilters extends Record<string, ChipFilterValue | string[]>> = {
  defaultPagination: PaginationCriteria;
  hasMore: boolean | undefined;
  isLoading?: boolean;
  objectsLength: number | undefined;
  setCriteria: Dispatch<SetStateAction<AllTableCriteria<TFilters>>>;
};

export const handlePaginationUpdate = <TFilters extends Record<string, ChipFilterValue | string[]>>({
  defaultPagination,
  hasMore = false,
  isLoading = false,
  objectsLength = 0,
  setCriteria,
}: UpdatePaginationArgs<TFilters>) => {
  if (isLoading) {
    return;
  }

  const hasReachedLimit = !hasMore && objectsLength === 0;

  if (hasReachedLimit) {
    setCriteria(prevCriteria => ({
      ...prevCriteria,
      [CriteriaDimension.PAGINATION]: defaultPagination,
    }));
    return;
  }

  setCriteria(prevCriteria => {
    const prevPagination = prevCriteria.pagination ?? defaultPagination;

    return {
      ...prevCriteria,
      [CriteriaDimension.PAGINATION]: {
        hasMore,
        pageSize: prevPagination.pageSize,
        pageNumber: prevPagination.pageNumber,
        totalCount: (prevPagination.pageNumber - 1) * prevPagination.pageSize + objectsLength,
      },
    };
  });
};
